import { action, thunk, persist } from 'easy-peasy';
import { httpGetCompanies } from "services/companies"

const model = {
  loading: false,
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  count: 0,
  setCount: action((state, payload) => {
    state.count = payload
  }),
  // My companies list
  companies: [],
  setCo: action((state, payload) => {
    if (payload) {
      state.companies = payload
    }
  }),
  getCompanies: thunk(async (actions, payload) => {
    actions.setLoading(true)
    httpGetCompanies().then(response => {
      if (response.status === 200 && response?.data) {
        actions.setCo(response.data)
        if (response?.data.length > 0) {
          actions.setCount(response?.data.length)
        }
        else {
          actions.setCount(0)
        }
      }
    }, error => {
      
    }).finally(() => {
      actions.setLoading(false)
    })
    
  }),
  // Selected portfolio

};

export default model;